module.exports = __webpack_public_path__ + "img/wallet-two-big.330fd2f4.svg";